export default __webpack_public_path__ + "static/media/icon_edit_trimming.44cbac17.svg";